import React from 'react';
import core from '@gin-betting/core';

import { Icon } from 'components';
import { convertNameToRuLocale } from 'utils';

import liveLabelGlyph from 'assets/svg/live-label.svg';
import './matchDetails.scss';

const {
    utils: { format },
} = core;

interface Props {
    title: string;
    startTime: string;
    isLive: boolean;
}

// => 01 October, 18:00
const FORMAT_DATE = 'dd MMMM, HH:mm';

const MatchDetails: React.FC<Props> = ({ title, startTime, isLive }) => {
    const convertedTitle = convertNameToRuLocale(title);

    const date = format(startTime, FORMAT_DATE);

    return (
        <div styleName="container" className="__app-MatchDetails-container">
            <div
                styleName="team"
                className="__app-MatchDetails-team"
                title={convertedTitle}
            >
                {convertedTitle}
            </div>

            <div
                styleName="date"
                className="__app-MatchDetails-date"
                title={date}
            >
                {isLive ? (
                    <Icon glyph={liveLabelGlyph} styleName="icon" />
                ) : (
                    date
                )}
            </div>
        </div>
    );
};

export default MatchDetails;
